export function buildSearchEndpoint(templateUrl, { country, cursor, term, onlyWithContracts }) {
  const path = templateUrl?.replace('*country*', encodeURIComponent(country))

  const params = new URLSearchParams()
  if (term) params.set('term', term)
  if (cursor) params.set('cursor', cursor)
  // Laravel's `boolean` rule accepts 1/0, not the strings 'true'/'false'
  if (onlyWithContracts) params.set('only_with_contracts', '1')

  const query = params.toString()
  return query ? `${path}?${query}` : path
}
